import React, { useEffect, useState } from 'react';
import MapViewer from './components/MapViewer';
import SelectLayer from './components/SelectLayer';
import LegendContent from './components/LegendContent';
import NavBar from './components/NavBar';
import ControlPanel from './components/ControlPanel'
import axios from 'axios';
import './App.css';

function App() {
  const [map1, setMap1] = useState('')
  const [map2, setMap2] = useState('')
  const [config, setConfig] = useState(null);
  const [map1Key, setMap1Key] = useState(1)
  const [map2Key, setMap2Key] = useState(2)
  const [map1Layer, setMap1Layer] = useState('')
  const [map2Layer, setMap2Layer] = useState('')
  const [map1LegendData, setMap1LegendData] = useState('')
  const [map1Data, setMap1Data] = useState({ label: "", varible: "", type: "", style: "" })
  const [map2LegendData, setMap2LegendData] = useState('')  
  const [map2Data, setMap2Data] = useState({ label: "", varible: "", type: "", style: "" }) 
  const [map1Zoom, setMap1Zoom] = useState(6)
  const [map2Zoom, setMap2Zoom] = useState(6)  
  const [map1Center, setMap1Center] = useState([-1.831239, -78.183406])
  const [map2Center, setMap2Center] = useState([-1.831239, -78.183406])
  const [map1Geom, setMap1Geom] = useState('')
  const [map2Geom, setMap2Geom] = useState('')
  const [loadMap1Option, setLoadMap1Option] = useState('')  
  const [loadMap2Option, setLoadMap2Option] = useState('')  

  useEffect(() => {
    const fetchConfig = async () => {
      const response = await axios.get('./config.json');
      setConfig(response.data);
    };
    fetchConfig();
  }, []);

  if (!config) {
    return <div>Loading...</div>;
  }

  const handleMap1Change = () => {
    setMap1Key(map1Key + 2)
  }
  
  const handleMap2Change = () => {
    setMap2Key(map2Key + 2)
  }

  return (
    <div className="app">
      <div className="navbar">
        <NavBar {...config.navbar} ></NavBar>
      </div>
      <div className="mapContainer">
        <div className="mapSection">
            <MapViewer mapKey={map1Key} layer={map1Layer} data={map1Data} zoom={map1Zoom} setZoom={setMap1Zoom} center={map1Center} setCenter={setMap1Center} setMap={setMap1} geom={map1Geom} {...config.map1} />
            <SelectLayer setKey={ handleMap1Change } setLayer={setMap1Layer} layerNames = {config.map1.layerNames} load={setLoadMap1Option} ></SelectLayer>
            <LegendContent geoserverUrl={config.map1.geoserverUrl} layerName={map1Layer} data={map1Data} setLegendData={setMap1LegendData} ></LegendContent>
        </div>
        <div className="mapSection">
            <MapViewer mapKey={map2Key} layer={map2Layer} data={map2Data} zoom={map2Zoom} setZoom={setMap2Zoom} center={map2Center} setCenter={setMap2Center} setMap={setMap2} geom={map2Geom} {...config.map2} />
            <SelectLayer setKey={handleMap2Change} setLayer={setMap2Layer} layerNames = {config.map2.layerNames} load={setLoadMap2Option} ></SelectLayer>
            <LegendContent geoserverUrl={config.map2.geoserverUrl} layerName={map2Layer} data={map2Data} setLegendData={setMap2LegendData} ></LegendContent>
        </div>
        <ControlPanel 
          geoserverUrl={config.map1.geoserverUrl}
          map1={map1}  
          map1Layer={map1Layer}
          handleMap1Change={handleMap1Change} 
          map1Data={map1Data}
          setMap1Data={setMap1Data}
          map1LegendData={map1LegendData}
          map2Layer={map2Layer}
          handleMap2Change={handleMap2Change}
          map2Data={map2Data}
          setMap2Data={setMap2Data}
          map2LegendData={map2LegendData}
          map2={map2} 
          legendConfig = {config.variables}
          setMap1Geom={setMap1Geom} 
          setMap2Geom={setMap2Geom} 
          loadMap1Option={loadMap1Option}
          loadMap2Option={loadMap2Option}
          setLoadMap1Option={setLoadMap1Option}
          setLoadMap2Option={setLoadMap2Option}> 
        </ControlPanel>

      </div>
    </div>
  );
}

export default App;
